import { State, Mutation, Action } from 'vuex-simple';
import { EventEmitter } from 'events';
import { sagaDispatchResolve } from 'vuex-coolstory';

import { EVENTS } from '@/Common/Runtime/events';
import { ux1Data } from '@/Common/Utils/General/Modules';

import { createNavigationStartAction } from './actions/creators';
import { CALL_NAVIGATION, FINISH_NAVIGATION } from './sagas/actionsTypes';

interface IDataApp {
	data: App.IApp;
}

type RouterPaylod = App.IEventAction<IDataApp>;

export default class RouteModule implements App.IRouteModule {
	constructor(routes: string[] = [], emitter: EventEmitter, config: App.IConfig | null = null) {
		this.routes = routes;
		this.emitter = emitter;
		this.config = config;
	}

	private emitter: EventEmitter;
	private config: App.IConfig | null;

	@State()
	public currentRoute: string = '';

	@State()
	public prevRoute: Common.StrNull = null;

	@State()
	public processing: boolean = false;

	@State()
	public currentPayload: App.PayloadData = null;

	@State()
	public routes: string[];

	@State()
	public routeParams: string = '';

	@Mutation()
	private setCurrentRoute(route: string): void {
		this.currentRoute = route;
	}

	@Mutation()
	private setRouteParams(params: string): void {
		this.routeParams = params;
	}

	@Mutation()
	private setPrevRoute(route: string): void {
		this.prevRoute = route;
	}

	@Mutation()
	private setPayload(payload: App.PayloadData): void {
		this.currentPayload = payload;
	}

	private setProcessing(flag: boolean): void {
		this.processing = flag;
	}

	@Action()
	public callUpdateRoute({ route = '', payload = null }: App.IUpdateRouteOptions): void {
		const { routes, currentRoute, currentPayload } = this;

		const [newRoute, params] = route.split('/');
		const hasRoute = routes.includes(newRoute);
		const isCurrentRoute = route === currentRoute;
		const isNewRoute = !isCurrentRoute || (isCurrentRoute && !ux1Data.isEqual(currentPayload || {}, payload || {}));

		if (hasRoute) {
			if (isNewRoute) {
				this.setData(newRoute, payload, params);
			} else {
				// eslint-disable-next-line no-console
				console.warn(`Route ${newRoute} is actual!`);
			}
		} else {
			throw new Error(`Route ${newRoute} not found!`);
		}
	}

	@Action()
	public async updateRoute({ route = '', payload = null }: App.IUpdateRouteOptions): Promise<void> {
		let isExternalRoute = !route || route.includes('/');
		let workRoute = route;

		this.setProcessing(true);
		this.emitter.emit(EVENTS.PRIVATE.TO_HOST, createNavigationStartAction({ route, payload }));

		if (!this.config?.isDev) {
			const actionPayload: RouterPaylod = await sagaDispatchResolve({
				type: CALL_NAVIGATION,
				resolver: FINISH_NAVIGATION
			});
			const {
				payload: { data }
			} = actionPayload;
			const nameApp = this.config?.nameApp;

			if (data.viewName) {
				isExternalRoute = !data.viewName.startsWith(`${nameApp}-`);

				if (!isExternalRoute) {
					workRoute = data.viewName;
				}
			}
			!isExternalRoute && this.callUpdateRoute({ route: workRoute, payload });
		}

		this.setProcessing(false);
	}

	private setData(route: string, payload: App.PayloadData, params = ''): void {
		this.setPrevRoute(this.currentRoute);
		this.setCurrentRoute(route);
		this.setPayload(payload);
		this.setRouteParams(params);
	}
}
